import { CSSProperties } from 'react'
import { SxProps } from '@mui/material'

export enum THEME_MODE {
  LIGHT = 'light',
  DARK = 'dark',
}

export const VISIBLE_HIDDEN: SxProps = {
  visible: 'hidden',
  overflow: 'hidden',
  height: 0,
  width: 0,
  flex: undefined,
}

export const FLEXIBLE: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  minWidth: 0,
}
